/** 展示信息 / 更新日志的内容语言（同客户端支持语言，后续由运营扩展） */
export interface ContentLanguage {
  code: string
  label: string
}

export const CONTENT_LANGUAGES: ContentLanguage[] = [
  { code: 'en', label: 'English' },
  { code: 'zh-CN', label: '简体中文' },
  // 后续由运营扩展时再放开
  // { code: 'zh-Hant', label: '繁體中文' },
  // { code: 'ja', label: '日本語' },
  // { code: 'ko', label: '한국어' },
  // { code: 'it', label: 'Italiano' },
  // { code: 'de', label: 'Deutsch' },
  // { code: 'es', label: 'Español' },
  // { code: 'fr', label: 'Français' },
  // { code: 'pt', label: 'Português' },
  // { code: 'vi', label: 'Tiếng Việt' },
  // { code: 'ms', label: 'Bahasa Melayu' },
  // { code: 'id', label: 'Bahasa Indonesia' },
]

/** 初始默认语言 */
export const DEFAULT_CONTENT_LANGUAGE = 'en'

export function contentLangLabel(code: string): string {
  return CONTENT_LANGUAGES.find((l) => l.code === code)?.label ?? code
}

/** 预设应用标签（先写死，后续由运营配置） */
export const PRESET_APP_TAGS = [
  'AI辅助',
  '自动化',
  '无需配置',
  '轻量级',
  '多语言',
  '离线可用',
  '免费',
  '生态集成丰富',
  '按量付费',
  '跨平台支持',
  '技术支持',
  '限时优惠',
  '通过安全审计',
]

/** 预设应用分类（选填，最多 2 个） */
export const PRESET_APP_CATEGORIES = [
  '效率工具',
  '协作沟通',
  '数据分析',
  '开发者工具',
  '设计创意',
  '人工智能',
  '客户管理',
  '财务法务',
]

export const MAX_APP_TAGS = 5
export const MAX_APP_CATEGORIES = 2
export const MAX_SCREENSHOTS = 6
